<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Редактирование страницы</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
                            <v-icon light>cached</v-icon>
                        </span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-layout flex wrap>
                    <v-flex xs12>
                        <v-subheader class="pa-0">Название</v-subheader>
                        <v-text-field
                            ref="page_title"
                            v-model="page.title"
                            v-validate="'required'"
                            data-vv-name="title"
                            :error-messages="errors.collect('title')"
                            text
                            solo
                            single-line
                            required/>
                    </v-flex>
                    <v-flex xs12>
                        <v-subheader class="pa-0">Текст</v-subheader>
                        <wysiwyg v-model="page.text"/>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Page from '../../../api/page'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'editPage',
        $_veeValidate: {
            validator: 'new'
        },
        components: { Loader },
        data: () => ({
            loader: false,
            loading: false,
            page: {
                title: '',
                description: ''
            },
            dictionary: {
                custom: {
                    title: {
                        required: 'Название не заполнено'
                    }
                }
            }
        }),
        mounted () {
            this.getPage(this.$route.params.pageSlug)
            this.$validator.localize('ru', this.dictionary)
        },
        methods: {
            getPage (slug) {
                this.loader = true

                Page
                    .getBySlug(slug)
                    .then(response => this.page = response.data.data)
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        this.$router.push({ name: 'pageRoot' })
                    })
                    .finally(() => this.loader = false)
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        Page
                            .edit(this.page)
                            .then(response => {
                                this.$store.commit('updatePage', response.data.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Отлично! Запись отредактировано',
                                    color: 'success'
                                })
                                this.$router.push({ name: 'pageRoot' })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.page = this.getPage(to.params.pageSlug)
            next()
        }
    }
</script>
